






























import {Media} from "@/ts/Media";
import Vue from "vue";
import {format} from "date-fns";
import {downloadFromUrl} from "@/ts/utils";
import {api} from "@/ts/constants";

export default Vue.extend({
    name: 'SelectionInfo',
    data: () => ({
        loading: {
            delete: false,
            reprocess: false,
            fixDate: false,
            download: false,
        },
    }),
    methods: {
        async downloadItems() {
            this.loading.download = true;
            if (this.selectedMedias.length < 5) {
                let fullMedias = await Promise.all(this.selectedMedias.map(m => this.$store.dispatch('apiRequest', {url: `photos/${m.id}`})));
                let promises = [];
                for (let media of fullMedias) {
                    console.log(media);
                    promises.push(downloadFromUrl(`${api}/photos/full/${media.id}`, media.filename));
                }
                await Promise.all(promises);
            } else {
                try {
                    let {zipId} = await this.$store.dispatch('apiRequest', {
                        url: `photos/batchDownload`,
                        body: {ids: this.selectedMedias.map(p => p.id)},
                    });
                    console.log('zip id', zipId);
                    let start = this.selectedMedias[0].createDate;
                    let end = this.selectedMedias[this.selectedMedias.length - 1].createDate;
                    [start, end] = [start, end].sort((a, b) => a.getTime() - b.getTime());
                    let startString = format(start, 'yyyy-MM-dd');
                    let endString = format(end, 'yyyy-MM-dd');
                    const filename = startString !== endString ? `photos_${startString}_${endString}` : startString;
                    await downloadFromUrl(`${api}/photos/zip/${zipId}`, `${filename}.zip`);
                } catch (e) {
                    await this.$store.dispatch('addSnack', {text: `Couldn't download files, ${e.message}`});
                    console.warn('cant download', e);
                }
            }
            this.clearSelection();
            this.loading.download = false;
        },
        async batchAction({
                              name = 'delete',
                              subTitleInfix = 'delete',
                              endpoint = 'batchDelete',
                              someFailText = 'Some items failed to delete',
                              failText = 'Deleting items failed',
                              successText = 'Successfully deleted items!',
                              confirmText = 'Delete',
                              reloadItems = false,
                              clearSelection = false,
                          }) {
            //@ts-ignore
            this.loading[name] = true;
            let allFailed = true;
            let allSuccess = false;
            let result = null;

            await (async () => {
                let accepted = await this.$store.dispatch('showPrompt', {
                    title: `Are you sure?`,
                    subtitle: `This will ${subTitleInfix} ${this.selectedMedias.length} item${this.selectedMedias.length === 1 ? '' : 's'}!`,
                    confirmText: confirmText,
                });
                if (!accepted) return;
                result = await this.$store.dispatch('apiRequest', {
                    url: `photos/${endpoint}`,
                    body: {ids: this.selectedMedias.map(p => p.id)},
                });
                if (Array.isArray(result.results)) {
                    allFailed = result.results.every((r: any) => r.success === false);
                    allSuccess = result.results.every((r: any) => r.success === true);
                }
                console.log('result', {allFailed, allSuccess}, result);
                if (allFailed)
                    return this.$store.dispatch('addSnack', {text: failText}).then();
                else if (allSuccess)
                    return this.$store.dispatch('addSnack', {text: successText}).then();
                else
                    return this.$store.dispatch('addSnack', {text: someFailText}).then();
            })();

            if (reloadItems && !allFailed) {
                this.$store.commit('reloadPhotos', true);
            }
            if (clearSelection && !allFailed) {
                this.clearSelection();
            }
            //@ts-ignore
            this.loading[name] = false;
            return result;
        },
        async deleteItems() {
            await this.batchAction({
                name: 'delete',
                subTitleInfix: 'delete',
                endpoint: 'batchDelete',
                someFailText: 'Some items failed to delete',
                failText: 'Deleting items failed',
                successText: 'Successfully deleted items!',
                confirmText: 'Delete',
                reloadItems: true,
                clearSelection: true,
            });
        },
        async reprocess() {
            await this.batchAction({
                name: 'reprocess',
                subTitleInfix: 'reprocess',
                endpoint: 'batchReprocess',
                someFailText: 'Some items failed to reprocess',
                failText: 'Reprocessing items failed',
                successText: 'Successfully reprocessed items!',
                confirmText: 'Reprocess',
                reloadItems: true,
                clearSelection: true,
            });
        },
        async fixDate() {
            await this.batchAction({
                name: 'fixDate',
                subTitleInfix: 'attempt to fix the date of',
                endpoint: 'batchFixDate',
                someFailText: 'Fixed some of the dates',
                failText: 'Fixing dates of items failed',
                successText: 'Successfully fixed dates of items!',
                confirmText: 'Fix dates',
                reloadItems: true,
                clearSelection: true,
            });
        },
        clearSelection() {
            this.$store.commit('lastSelectedPhoto', null);
            this.$store.commit('clearPhotoSelection');
            this.$store.commit('delayedIsSelecting', false);
        },
    },
    computed: {
        firstDate(): string {
            return format(this.selectedMedias[0].createDate, 'yyyy-MM-dd');
        },
        lastDate(): string {
            return format(this.selectedMedias[this.selectedMedias.length - 1].createDate, 'yyyy-MM-dd');
        },
        selectedMedias(): Media[] {
            let medias: Media[] = Object.values(this.$store.state.photoSelection);
            return medias.sort((a: Media, b: Media) => a.createDate.getTime() - b.createDate.getTime());
        },
        isSelecting(): boolean {
            return this.$store.getters.isSelecting;
        },
        selectionCount(): number {
            return Object.keys(this.$store.state.photoSelection).length
        },
    },
})
